import { render } from "./PercentageIncomesBySource.vue?vue&type=template&id=6c6a3ccb"
import script from "./PercentageIncomesBySource.vue?vue&type=script&lang=js"
export * from "./PercentageIncomesBySource.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__